import { render, staticRenderFns } from "./ScientificDegreesView.vue?vue&type=template&id=b9a2f13e"
import script from "./ScientificDegreesView.vue?vue&type=script&lang=js"
export * from "./ScientificDegreesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports